import React, {useEffect} from "react";
import {IonRouterLink} from "@ionic/react";
import "./dashboard.css";

import {AppButton, AppCards} from "../../components";

import Service from "../../assets/images/servizi.png";
import Preventivo from "../../assets/images/preventivo.svg";
import {useLazyQuery} from "@apollo/client";
import {GET_ALL_MY_INVOICES} from "../../graphql/queries/dylog.query";
import toast from "react-hot-toast";
import {useHistory} from "react-router-dom";
import {isAuthenticated} from "../../lib/utils/auth.utils";

const Dashboard = () => {
  const router = useHistory();
  const [getMyInvoices] = useLazyQuery(GET_ALL_MY_INVOICES, {
    variables: {
      options: {
        limit: 1,
        offset: 0,
      },
    },
    fetchPolicy: "network-only",
    onCompleted(data) {
      const actualData = data?.getMyInvoices?.data ?? [];

      if (actualData.length > 0) {
        toast(
          (_t) => (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                // background: "#ff7300",
                color: "#000",
              }}
            >
              Hai una fattura non pagata!
              <AppButton
                onClick={() => {
                  toast.dismiss(_t.id);
                  router.push("/personale/invoices");
                }}
                buttonType="warning"
                style={{
                  marginTop: "10px",
                }}
              >
                Vai alla fatture
              </AppButton>
            </div>
          ),
          {
            position: "bottom-right",
            duration: 5000,
            style: {
              border: "1px solid #713200",
              padding: "16px",
              color: "#713200",
            },
          }
        );
      }
    },
  });

  useEffect(() => {
    if (isAuthenticated()) {
      getMyInvoices();
    }
  }, [getMyInvoices, isAuthenticated]);

  return (
    <div className="full-page-content">
      <IonRouterLink href="/servizi">
        <AppCards title="Richiedi una pratica" image={Service} />
      </IonRouterLink>

      <IonRouterLink href="/preventivo">
        <AppCards title="Richiedi un preventivo" image={Preventivo} />
      </IonRouterLink>
    </div>
  );
};

export default Dashboard;
